module.exports = __webpack_public_path__ + "static/media/e-logoo.2cb51d82.jpg";